import { Outlet, Link } from "react-router-dom";


const NoPage = () => {
  return <>
      <center>
          <h1>No PAGE FOUND</h1>
          <Link to="/timer">GO TO TIMER &#x23F2;</Link>
      </center>
  </>
};

export default NoPage;